__turbopack_context__.v({
  "className": "la_belle_aurore_b2e0a89b-module__k2h_NW__className",
  "variable": "la_belle_aurore_b2e0a89b-module__k2h_NW__variable",
});
